import styled from 'styled-components'

export const Container = styled.div<any>`
  position: relative;
  display: flex;
  max-width: 400px;
  min-height: 180px;
  align-items: center;
  border-color: ${props => props.theme.form.passiveColor};
  border: 1px solid ${props => props.isLoading ? 'transparent' : props.theme.form.passiveColor};
  border-radius: ${props => props.theme.form.borderRadius};
  padding: 1px 20px;
  cursor: ${props => props.isLoading ? 'wait' : 'default'};

  > div {
    width: 100%;
  }

  button {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    color: ${props => props.theme.palette.primary.alpha};
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    outline: 0;
  }
`
